import React from 'react';
import { Table } from '@mui/material';
import TableFooterNew from '@src/components/NewTable/TableFooterNew';
import { StyledTable } from './index.style';
import CustomTableHeader from './TableHeader';
import CustomTableBody from './TableBody';

const CustomTable = ({
  columns,
  cellWidth,
  headerPadding,
  minWidth,
  headerStyle,
  cellHeight,
  className,
  data,
  page,
  bodyStyle,
  total,
  rowsPerPage,
  onChangeRowPage,
  onChangePage,
  onRowClick,
  rowsPerPageOptions,
  styleFooter,
  isRowClickable = true,
  hideFooter = false,
  showNumber = true,
}) => (
  <>
    <StyledTable
      cellWidth={cellWidth}
      headerPadding={headerPadding}
      className={`table-wrapper ${className}`}
      cellHeight={cellHeight}
      isRowClickable={isRowClickable}
    >
      <Table style={{ minWidth }}>
        <CustomTableHeader
          columns={columns}
          headerStyle={headerStyle}
          showNumber={showNumber}
        />
        <CustomTableBody
          bodyStyle={bodyStyle}
          columns={columns}
          data={data}
          page={page}
          showNumber={showNumber}
          onRowClick={onRowClick}
          limit={rowsPerPage}
        />
      </Table>
      {data.length > 0 && !hideFooter && (
        <TableFooterNew
          total={total}
          page={page}
          rowsPerPage={rowsPerPage}
          onChangeRowPage={onChangeRowPage}
          onChangePage={onChangePage}
          rowsPerPageOptions={rowsPerPageOptions}
          styleFooter={styleFooter}
          styleSelect={{
            transform: 'translateX(5%) translateY(8%)',
          }}
          minWidth={minWidth}
        />
      )}
    </StyledTable>
  </>
);

export default CustomTable;
